import {connect} from "react-redux";
import {DispatchProps, HtmlInteractions, InnerProps, StateProps} from "../components/HtmlInteractions";
import {RootState, ThunkDispatch} from "../types";
import {routerTools, Routes} from "../utils/router";
import {doDownloadHtmlDataXML, doGetHtmlJson, doGetHtmlSignatures} from "../actions/thunks/signatures";
import {gotHTMLJson, gotHtmlSignatures} from "../actions/signatures";
import {userIsAllowed} from "../utils/commons";
import {doGetUserCredits} from "../actions/thunks/users";

function mapStateToProps({user, html}: RootState): StateProps {
    return {
        apiKeys: user.credentials,
        signatures: html.signatures,
        total: html.total,
        stats: user.credits?.webpage_api,
        json: html.json,
        isAllowed: userIsAllowed(user.credits, "webpage_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToDocumentation: () => window.open(Routes.DOCS, "_blank"),
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGetHtmlSignatures: (q) => dispatch(doGetHtmlSignatures(q)),
        onResetHtmlSignatures: () => dispatch(gotHtmlSignatures({items: undefined as any, total: 0})),
        onDownloadHtmlXML: (sig) => dispatch(doDownloadHtmlDataXML(sig)),
        onGetHtmlJson: (sig) => dispatch(doGetHtmlJson(sig)),
        onCleanJson: () => dispatch(gotHTMLJson(undefined)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(HtmlInteractions);
